/**
 * Renders a list of legal-document sections.
 *
 * Each section has ``title`` and ``body`` — ``body`` is either a
 * string (paragraph) or a string array (rendered as a bulleted list).
 * Section keys come from one of the language objects in
 * ``./content/{privacy,terms,offer}.js``.
 */

export default function LegalSections({ sections }) {
  if (!Array.isArray(sections) || sections.length === 0) return null;
  return (
    <>
      {sections.map((s, i) => (
        <section key={i} className="mt-6">
          <h2 className="text-lg font-semibold text-slate-900 mt-6 mb-2">
            {s.title}
          </h2>
          {Array.isArray(s.body) ? (
            <ul className="list-disc pl-5 space-y-1 text-slate-700">
              {s.body.map((line, j) => (
                <li key={j}>{line}</li>
              ))}
            </ul>
          ) : (
            <p className="text-slate-700 whitespace-pre-wrap">{s.body}</p>
          )}
        </section>
      ))}
    </>
  );
}
